export function getLoanPurposeDecoded(encodedLoanPurpose: string) {
    if (typeof encodedLoanPurpose === 'string') {
        return decodeURIComponent(encodedLoanPurpose).replaceAll('-', ' ')
    }
    return encodedLoanPurpose
}
